import styled from "styled-components";
import { ButtonTag } from "../../components/Button/styles";

export const PromoWrapper = styled.article`
  position: relative;
  
  margin-bottom: 50px;
`;

export const PromoContainer = styled.form`
  position: relative;
  
  ${ButtonTag} {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: -1px;
    
    padding: 21px 32px;
    
    background-color: ${({ theme }) => theme.white};
  }
`;

export const PromoInput = styled.input`
  width: 100%;
  margin: 0;
  padding: 20px;
  padding-right: 95px;
  
  font-family: inherit;
  font-size: 16px;
  line-height: 1;
  color: inherit;
  text-transform: uppercase;
  
  border: 1px solid ${({ isInvalid, theme }) => isInvalid ? theme.red : '#ebebeb' };
  border-radius: 6px 50px 50px 6px;
  outline: none;
  
  transition: border-color 0.3s;
  
  &::placeholder {
    text-transform: capitalize;
  }
  
  &:hover,
  &:focus {
    border-color: ${({ theme }) => theme.blue};
  }
`;

export const PromoCross = styled.div`
  position: absolute;
  z-index: 1;
  top: 50%;
  transform: translateY(-50%);
  right: 100px;
  
  display: flex;
  
  pointer-events: none;
`;

export const PromoError = styled.p`
  position: absolute;
  bottom: -5px;
  transform: translateY(100%);
  left: 0;
  margin: 0;
  padding: 0;
  
  font-size: 12px;
  line-height: 1;
  color: ${({ theme }) => theme.red};
`;

export const PromoSuccessMessage = styled.p`
  position: absolute;
  bottom: -5px;
  transform: translateY(100%);
  left: 0;
  
  margin: 0;
  padding: 0;
  
  font-size: 14px;
  line-height: 17px;
  color: ${({ theme }) => theme.green};
  text-align: center;
`;
